import { Row } from "@tanstack/react-table"
import { Checkbox } from "../ui/checkbox"

interface DataTableCheckboxProps {
    row: Row<any>
}
export const DataTableCheckbox = ({ row }: DataTableCheckboxProps) => {
    return (
        <div className="flex items-center justify-center cursor-pointer" onClick={(e) => {
            e.stopPropagation()
            row.toggleSelected(row.getIsSelected() ? false : true)
        }}>
            <Checkbox
                checked={row.getIsSelected()}
                aria-label="Select row"
                className="translate-y-0.5"
            />
        </div>
    )
}